// extracted by mini-css-extract-plugin
export default {"wrapper":"MainTitle_wrapper__K5Rs6","title":"MainTitle_title__iKvd4","subtitle":"MainTitle_subtitle__XtUHW"};